<grid #grid [tableSettings]="tableSettings" [gridSettings]="gridSettings" (onRowReorder)="onRowReorder($event)" rte="1gM"></grid>